import { Component, Input } from '@angular/core';
import { formatRating } from '../attraction-utils';

/**
 * `★ 4.7 · 103 reviews` — the aggregate rating row (Android `RatingRow`).
 *
 * The contract carries no review text, so there are no review cards anywhere; this single row is the
 * whole rating summary on a card/tile. Renders "No reviews yet" when there is no real aggregate.
 * `compact` shrinks it for use inside the list card and carousel tile.
 */
@Component({
    selector: 'app-attraction-rating-row',
    template: `
    <span *ngIf="!hasRating" class="no-reviews">{{ 'attractions.noReviews' | translate }}</span>
    <ng-container *ngIf="hasRating">
      <app-attr-icon name="star" [size]="compact ? 13 : 15" class="star"></app-attr-icon>
      <span class="score">{{ formattedRating }}</span>
      <span class="count">{{ 'attractions.reviews' | translate:{ count: reviewCount || 0 } }}</span>
    </ng-container>
  `,
    styles: [`
    :host {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      color: var(--attr-on-surface, #1A2B49);
    }
    .star { color: var(--attr-on-surface, #1A2B49); }
    .score { font-weight: 600; font-size: 14px; }
    :host(.compact) .score { font-size: 12px; }
    .count {
      color: var(--attr-on-surface-variant, #5A6B84);
      font-size: 13px;
      margin-left: 2px;
    }
    :host(.compact) .count { font-size: 12px; }
    .no-reviews {
      color: var(--attr-on-surface-variant, #5A6B84);
      font-size: 13px;
    }
  `],
    host: { '[class.compact]': 'compact' },
    standalone: false
})
export class AttractionRatingRowComponent {
  @Input() rating: number | null | undefined = null;
  @Input() reviewCount: number | null | undefined = null;
  @Input() compact = false;

  get hasRating(): boolean {
    return this.rating !== null && this.rating !== undefined && (this.reviewCount ?? 0) > 0;
  }

  get formattedRating(): string {
    return formatRating(this.rating);
  }
}
